import styles from "./HQEditModal.module.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import InputText from "../../../../CommonComponents/InputControls/InputText";
import InputSelect from "../../../../CommonComponents/InputControls/InputSelect";
import { GENDER_OPTIONS } from "../../../../../constant";
import InputPhoneNumber from "../../../../CommonComponents/InputControls/InputPhoneNumber";
import useNotification from "../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import InputDate from "../../../../CommonComponents/InputControls/InputDob";
import dayjs from "dayjs";
import AuthServices from "../../../../../services/AuthServices";

const HQEditModal = ({ isOpen, onCancel, onSubmit, data }) => {
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  const [initialData, setInitialData] = useState({});
  const [form] = Form.useForm();
  const dateFormat = "YYYY-MM-DD";


  useEffect(() => {
    if (isOpen) {
      setLoading(false);
      const initData = {
        companyCountry: data.companyAddress.country,
        companyfederalTaxID: data.companyAddress.fedaralTaxId,
        companyContactAddress: data.companyAddress.corpContact,
        companyState: data.companyAddress.state,
        companyZip: data.companyAddress.zip,
      };
      setInitialData(initData);
      form.setFieldsValue(initData);
    }
  }, [isOpen]);

  const handleOk = () => {
    onCancel(false);
  };
  const handleCancel = () => {
    onCancel(false);
  };

  const onFinish = async (values) => {
    console.warn("values", values);

    try {
      setLoading(true);
      var payload = {
        _id: data._id,
        companyAddress: {
          country: values.companyCountry,
          fedaralTaxId: values.companyfederalTaxID,
          corpContact: values.companyContactAddress,
          state: values.companyState,
          zip: values.companyZip,
        },
      };
      console.log("payload payload", payload)
      const res = await EnterpriseServices.UpdateEnterprise(payload);
      if (res.statusCode === 1) {
        onSubmit();
        onCancel(false);
        showNotification("Company HQ address updated Successfully");
        setLoading(false);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating banner", error);
        handleError(error.description);
      } else {
        handleError("Error: company banner is not updated.");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const validator = (_, { value, countryCode, areaCode, phoneNumber }) => {
    const regex = /^\+\d{1,15}$/;
    const number = "+" + countryCode + areaCode + phoneNumber;

    if (regex.test(number)) {
      return Promise.resolve();
    } else {
      return Promise.reject("Invalid phone number");
    }
  };

  const handleChange = (key, value) => {
    setInitialData({ ...initialData, [key]: value });
  };

  const handleZipCodeUpdate = async () => {
    let address = await AuthServices.FindAddress({ zip: initialData.zip });
    if (address?.data?.length > 0) {
      form.setFieldsValue({
        state: address.data[0].city + ", " + address.data[0].state,
        country: address.data[0].country,
      });
    } else {
      showNotification("Please enter correct zipcode", "error");
    }
  };

  return (
    <>
      <Modal
        title="Company HQ Address"
        open={isOpen}
        footer={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          layout="vertical"
          style={{ marginTop: 20 }}
          className={styles.form_wrap}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={initialData}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Enter your Zip code"
                label={"PostCode/Zip"}
                name={"companyZip"}
                onChange={handleChange}
                onBlur={handleZipCodeUpdate}
                rules={[
                  {
                    required: true,
                    message: "Please enter zip code",
                  },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }
                      if (isNaN(value)) {
                        return Promise.reject("Zip code has to be a number.");
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Enter state/city"
                label={"State/City"}
                disabled={true}
                name={"companyState"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "State is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Enter your country"
                label={"Country"}
                name={"companyCountry"}
                disabled={true}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "Country is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Enter address"
                label={"Address"}
                name={"companyContactAddress"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "Address is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Federal Tax ID / VAT"
                label={"Federal Tax ID"}
                name={"companyfederalTaxID"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "Federal Tax ID is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
          </Row>
          <div className={styles.footer}>
            <Form.Item>
              <Button
                className={styles.submit_btn}
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Form.Item>
            <Button
              className={styles.cancel_btn}
              type="secondary"
              loading={false}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default HQEditModal;
